module.exports = __webpack_public_path__ + "static/media/YellowCard.20a03686.svg";